window.VariationsWidget ?= {}
VariationsWidget.Views ?= {}

VariationsWidget.Views.Error = Backbone.View.extend
  show: -> @$el.show()
  hide: -> @$el.hide()


module.exports = VariationsWidget.Views.Error



// WEBPACK FOOTER //
// ./modules/variations/frontend/views/error.coffee